import React from 'react';
import TagList from '../shared/TagList';

const MangaGenresSection = ({ genres }) => {
  // Transform the genres data to ensure it's in the right format
  const formattedGenres = Array.isArray(genres) 
    ? genres.map(genre => typeof genre === 'string' ? genre : genre.name || genre) 
    : [];

  return (
    <div className="manga-tag-group">
      <h4>Genres</h4>
      <TagList 
        tags={formattedGenres} 
        emptyMessage="No genres listed" 
        className="manga-tags"
        tagClassName="manga-tag"
      />
    </div>
  );
};

export default MangaGenresSection;